import { twMerge } from "tailwind-merge";

export const cx = twMerge;
